"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var BasePieChart = /** @class */ (function (_super) {
    __extends(BasePieChart, _super);
    function BasePieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasePieChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_innerRadius":
                return utils_1.parseNumberWithAuto(value);
            case "_radianFunc":
            case "_toolTipFunc":
            case "_sortingFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    BasePieChart.prototype.defaultOptions = function () {
        return {
            _innerRadius: 0,
            _radianFunc: function (d) { return d.value; },
            _toolTipFunc: function (d) { return d.category; },
            _sortingFunc: function (a, b) { return a.value - b.value; },
        };
    };
    BasePieChart.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("arctip");
        this._groups = this.appendGroupT(_1.Component).data([])
            .options({
            _x: function (d) { return _this._outerRadius; },
            _y: function (d) { return _this._outerRadius; },
        });
        this._arcs = this._groups.appendT(element_1.Arc).options({
            _innerR: this._getArcInnerR(),
            _outerR: this._getArcOuterR(),
            _startAngle: this._getStartAngle(),
            _endAngle: this._getEndAngle(),
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._groups.dom)
                    .renderHTML(function (d, i) { return _this._toolTipData[i]; });
            },
        });
    };
    BasePieChart.prototype.prepare = function () {
        this._outerRadius = Math.min(this._getGeometry("_height", false) / 2, this._getGeometry("_width", true) / 2);
        this._radianData = this._getRadianData();
        this._groups.data(this._radianData);
        this._toolTipData = this._getToolTipData();
        this.setupProxy({
            arc: "_arcs",
        });
    };
    // Get the inner radius of the chart
    BasePieChart.prototype._getInnerRadius = function () {
        return this.getOption("_innerRadius");
    };
    // Set the outer and iner radius, the start and end angles of arcs
    BasePieChart.prototype._getArcInnerR = function () {
        var _this = this;
        return function (d, i) { return _this.getOption("_innerRadius"); };
    };
    BasePieChart.prototype._getArcOuterR = function () {
        var _this = this;
        return function (d, i) { return _this._outerRadius; };
    };
    BasePieChart.prototype._getStartAngle = function () {
        return function (d, i) { return d.startAngle / Math.PI * 180; };
    };
    BasePieChart.prototype._getEndAngle = function () {
        return function (d, i) { return d.endAngle / Math.PI * 180; };
    };
    // Get the data for arcs and tooltip
    BasePieChart.prototype._getRadianData = function () {
        return d3.pie()
            .value(this.getOption("_radianFunc"))
            .sort(this.getOption("_sortingFunc"))(this.datum);
    };
    BasePieChart.prototype._getToolTipData = function () {
        return this.datum.map(this.getOption("_toolTipFunc"));
    };
    return BasePieChart;
}(_1.Component));
exports.BasePieChart = BasePieChart;
var PieChart = /** @class */ (function (_super) {
    __extends(PieChart, _super);
    function PieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChart.prototype.defaultOptions = function () {
        return __assign({ _padAngle: 0 }, _super.prototype.defaultOptions.call(this));
    };
    /*
      If the inner radius or angular span is small relative to the pad angle, it may not be possible to maintain parallel edges between adjacent arcs.
      In this case, the inner edge of the arc may collapse to a point, similar to a circular sector.
      For this reason, padding is typically only applied to annular sectors (i.e., when innerRadius is positive).
      The recommended minimum inner radius when using padding is outerRadius * padAngle / sin(θ),
        where θ is the angular span of the smallest arc before padding.
      For example, if the outer radius is 200 pixels and the pad angle is 0.02 radians,
        a reasonable θ is 0.04 radians, and a reasonable inner radius is 100 pixels.
      Reference --- https://github.com/d3/d3-shape
      In experiments, however, outerRadius * padAngle^0.5 / sin(θ) fits better.
    */
    PieChart.prototype._getInnerRadius = function () {
        var theta = d3.min(this._radianData, function (d) { return d.endAngle - d.startAngle; });
        var minInnerR = this._outerRadius * Math.sqrt(this.getOption("_padAngle")) / Math.sin(theta);
        return (this.getOption("_padAngle") !== 0 && this.getOption("_innerRadius") < minInnerR) ?
            minInnerR : this.getOption("_innerRadius") * this._outerRadius;
    };
    PieChart.prototype._getArcInnerR = function () {
        var _this = this;
        return function (d, i) { return _this._getInnerRadius(); };
    };
    PieChart.prototype._getRadianData = function () {
        return d3.pie()
            .padAngle(this.getOption("_padAngle"))
            .value(this.getOption("_radianFunc"))
            .sort(this.getOption("_sortingFunc"))(this.datum);
    };
    PieChart.prototype._getEndAngle = function () {
        return function (d, i) { return (d.endAngle - d.padAngle) / Math.PI * 180; };
    };
    return PieChart;
}(BasePieChart));
exports.PieChart = PieChart;
//# sourceMappingURL=pie-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/pie-chart.js
// module id = 1145
// module chunks = 0 1